import React from 'react';
import { useLoaderData } from 'react-router-dom';
import './StudentsDahboard.css';



const PendingDetails = () => {
    const jobs = useLoaderData();

    return (
        <div>
               <div className=' pt-10 px-10'>
            <div className='border-2 rounded w-full h-[633px] shadow-md'>
                <div className='flex flex-col px-5 py-3'>
                    <h1 className='mainText'>Class 10 | NC Bangla Version</h1>
                    <p className='mainPera'>Job ID : {jobs.jobId} | Posted Date : {jobs.joiningDate}</p>
                </div>
                <hr className='h-1' />

                <div className='px-5 py-5'>
                    <div className='flex justify-between items-center'>
                        <div className='w-72 h-20'>
                            <h1 className='tittleHeading'>Student Gender :</h1>
                            <p className='tittlePeraStudents'>{jobs.gender}</p>
                        </div>
                        <div className='w-72 h-20'>
                            <h1 className='tittleHeading'>Subjects : </h1>
                            <p className='tittlePeraStudents'>{jobs.requiredSubject}</p>
                        </div>
                    </div>

                    <div className='flex justify-between items-center'>
                        <div className='w-72 h-20'>
                            <h1 className='tittleHeading'>Class : </h1>
                            <p className='tittlePeraStudents'>{jobs.class}</p>
                        </div>
                        <div className='w-72 h-20'>
                            <h1 className='tittleHeading'>Institute Name : </h1>
                            <p className='tittlePeraStudents'>{jobs.Institute}</p>
                        </div>
                    </div>

                    <div className='flex justify-between items-center'>
                        <div className='w-72 h-20'>
                            <h1 className='tittleHeading'>Preferred Tutor : </h1>
                            <p className='tittlePeraStudents'>{jobs.tutorGender}</p>
                        </div>
                        <div className='w-72 h-20'>
                            <h1 className='tittleHeading'>Tutoring Time : </h1>
                            <p className='tittlePeraStudents'>{jobs.TutoringTime}</p>
                        </div>
                    </div>

                    <div className='flex justify-between items-center'>
                        <div className='w-72 h-20'>
                            <h1 className='tittleHeading'>Number of Students :</h1>
                            <p className='tittlePeraStudents'>{jobs.numberOfStudents}</p>
                        </div>
                        <div className='w-72 h-20'>
                            <h1 className='tittleHeading'>Tutoring Days : </h1>
                            <p className='tittlePeraStudents'>{jobs.tutoringDays} Days/ Week</p>
                        </div>
                    </div>

                    <div className='flex justify-between items-center'>
                        <div className='w-72 h-20'>
                            <h1 className='tittleHeading'>Address :</h1>
                            <p className='tittlePeraStudents'>{jobs.city}, {jobs.district}, Bangladesh</p>
                        </div>
                        <div className='w-72 h-20'>
                            <h1 className='tittleHeading'>Salary : </h1>
                            <p className='tittlePeraStudents'>{jobs.salary} BDT</p>
                        </div>
                    </div>
                    <div className='mt-10'>
                        {/* button */}
                    </div>

                </div>
            </div>
        </div>
        </div>
    );
};

export default PendingDetails;